import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

// 应用启动时恢复用户状态（Vuex的global.js已经自动处理了localStorage的恢复）
// 这里可以添加其他初始化逻辑

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
